import React, { FunctionComponent } from 'react';
import { Fade, Grid, Typography } from '@mui/material';
import moment from 'moment';

import { ILessonHistory } from '../../../../../../../../../store/V2/LessonHistorySlice';
import { useAppSelector } from '../../../../../../../../../hooks';
import { getAuthState } from '../../../../../../../../../store/AuthSlice';
import {
  checkUserPermission,
  getFormatedDurationByMinutes,
} from '../../../../../../../../../helper';
import { USER_PERMISSION_INDIVIDUALS } from '../../../../../../../../../store/V2/RolesSlice';

interface ClassDetailsTabProps {
  lessonHistory: ILessonHistory;
}

const DetailItem = (props: { title: string; description: string }) => {
  const { title, description } = props;

  return (
    <Grid container columnSpacing="16px">
      <Grid item xs={6}>
        <div>
          <Typography fontSize="14px" fontWeight={500} color="#94A3B8">
            {title}
          </Typography>
        </div>
      </Grid>
      <Grid item xs={6}>
        <div>
          <Typography fontSize="14px" fontWeight={500} color="#1E293B">
            {description}
          </Typography>
        </div>
      </Grid>
    </Grid>
  );
};

const ClassDetailsTab: FunctionComponent<ClassDetailsTabProps> = ({
  lessonHistory,
}) => {
  // Store
  const authState = useAppSelector(getAuthState);

  const authUser = authState.user;
  const startMoment = moment(lessonHistory.start);
  const endMoment = lessonHistory.end ? moment(lessonHistory.end) : undefined;

  const formatedDuration =
    typeof lessonHistory.duration === 'number'
      ? getFormatedDurationByMinutes({ minutes: lessonHistory.duration })
      : '';

  return (
    <Fade in>
      <div>
        <div style={{ marginBottom: '16px' }}>
          <Typography fontWeight={600} fontSize="16px">
            Class Information
          </Typography>
        </div>
        <div>
          <Grid container rowSpacing="12px" columnSpacing="32px">
            {checkUserPermission(authUser, {
              adminLessonHistoryCompletedTab: [
                USER_PERMISSION_INDIVIDUALS.ADMIN_LESSON_HISTORY_COMPLETED_TAB_DATE_TIME,
              ],
            }) ? (
              <>
                <Grid item xs={12} sm={6}>
                  <div>
                    <DetailItem
                      title="Class Date"
                      description={startMoment.format('ddd MMM DD YYYY')}
                    />
                  </div>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <div>
                    <DetailItem
                      title="Class start time"
                      description={startMoment.format('hh:mm A')}
                    />
                  </div>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <div>
                    <DetailItem
                      title="Class end time"
                      description={
                        endMoment ? endMoment.format('hh:mm A') : '-'
                      }
                    />
                  </div>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <div>
                    <DetailItem
                      title="Class duration"
                      description={formatedDuration || '-'}
                    />
                  </div>
                </Grid>
              </>
            ) : null}
            {checkUserPermission(authUser, {
              adminLessonHistoryCompletedTab: [
                USER_PERMISSION_INDIVIDUALS.ADMIN_LESSON_HISTORY_COMPLETED_TAB_SUBJECT,
              ],
            }) ? (
              <Grid item xs={12} sm={6}>
                <div>
                  <DetailItem
                    title="Subject"
                    description={lessonHistory.subject || '-'}
                  />
                </div>
              </Grid>
            ) : null}
            {checkUserPermission(authUser, {
              adminLessonHistoryCompletedTab: [
                USER_PERMISSION_INDIVIDUALS.ADMIN_LESSON_HISTORY_COMPLETED_TAB_CURRICULUM,
              ],
            }) ? (
              <Grid item xs={12} sm={6}>
                <div>
                  <DetailItem
                    title="Curriculum"
                    description={lessonHistory.curriculum || '-'}
                  />
                </div>
              </Grid>
            ) : null}
            {checkUserPermission(authUser, {
              adminLessonHistoryCompletedTab: [
                USER_PERMISSION_INDIVIDUALS.ADMIN_LESSON_HISTORY_COMPLETED_TAB_GRADE,
              ],
            }) ? (
              <Grid item xs={12} sm={6}>
                <div>
                  <DetailItem
                    title="Grade"
                    description={lessonHistory.grade || '-'}
                  />
                </div>
              </Grid>
            ) : null}
          </Grid>
        </div>
      </div>
    </Fade>
  );
};

export default ClassDetailsTab;
